<template>
  <div
    style="margin-bottom: -40px; padding: 1.25rem"
    v-if="!onload"
  >
    <div
      class="alert alert-order alert-dismissible mb-2 d-flex align-items-start"
    >
      <button 
        type="button"
        class="close" 
        data-dismiss="alert"
      >
        <span>×</span>
      </button>
      <div class="d-flex">
        <span class="font-weight-bold mr-1">
          <i class="fa-solid fa-circle-info pr-1" />
        </span>
      </div>
      <span v-if="!$parent.newVersionOrder">
        {{ $t('Congratulations!') }}
        {{ $t("You've been granted access to the menu's new version, which will allow you to access information faster. Some old information may temporarily not available as it's under development.") }}
        <b><a class="u_line" href="javascript:void(0);" @click="switchNewVersionOrderList">{{ $t("Click to switch new version.") }}</a></b>
      </span>
      <span v-if="$parent.newVersionOrder">
        {{ $t("Your store is now using the new version of the menu. Some old information may temporarily not be available as it's undergoing development.") }}
        <b><a class="u_line" href="javascript:void(0);" @click="switchOldVersionOrderList">{{ $t("Click to return to the old version.") }}</a></b>
      </span>
    </div>
  </div>
</template>
<script>
  import Cookies from "js-cookie";
  export default {
    name: "AlertOrder",
    data() {
      return {
        urlSecurity: process.env.CENTRAL_ACC_URL + "/security",
        countDownTimer: 0,
        alertCountdownChangePassword: false,
        alertConfirmBusiness: false,
        alertConfirmBankAccount: false,
        alertConfirmFlatrate: false,
        alertAdvanceSalesOrderNotify: false,
        numPageCountdown: 0,
        numPageCredit: 0,
        numPageBankAccount: 0,
        numPageFlatrate: 0,
        numAdvanceSalesOrderNotify: 0,
        onload: true,
        dayExpiration: 90,
        tenant: JSON.parse(Cookies.get('tenant')),
        user: JSON.parse(Cookies.get('user'))
      };
    },
    methods: {
      getCountdownChangePassword: async function () {
        this.onload = true;
        this.dayExpiration = this.tenant.password_policy;
  
        // แปลงวันที่ล่าสุดให้กลายเป็นวัตถุ Date
        const last = new Date(this.user.password_change_date);
  
        // หาวันปัจจุบัน
        const today = new Date();
  
        // หาผลต่างของวันที่ล่าสุดและวันปัจจุบัน
        const timeDiff = today.getTime() - last.getTime();
  
        // แปลงผลต่างเวลาที่ได้เป็นจำนวนวัน
        const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
  
        let countDown = this.dayExpiration - daysDiff;
        if (countDown <= 7) {
          if (countDown > 0) {
            this.countDownTimer = countDown;
          }
          this.alertCountdownChangePassword = true;
          this.numPageCountdown = 1;
        } else {
          this.alertCountdownChangePassword = false;
          this.numPageCountdown = 0;
        }
      },
      getBusinessInfoList: async function () {
        if (this.tenant.need_upgrade_business_info) {
          this.alertConfirmBusiness = true;
          this.numPageCredit = 1;
        } else {
          this.alertConfirmBusiness = false;
          this.numPageCredit = 0;
        }
      },
      getBankAccount: async function () {
        if (this.tenant.need_upgrade_bank_account) {
          this.alertConfirmBankAccount = true;
          this.numPageBankAccount = 1;
        } else {
          this.alertConfirmBankAccount = false;
          this.numPageBankAccount = 0;
        }
      },
      getFlatRate: async function () {
        if (this.tenant.need_upgrade_flat_rate) {
          this.alertConfirmFlatrate = true;
          this.numPageFlatrate = 1;
        } else {
          this.alertConfirmFlatrate = false;
          this.numPageFlatrate = 0;
        }
        // console.log(this.getFlatRate());
      },
      getAlertAdvanceSalesOrderNotify: async function () {
        if (this.tenant.need_upgrade_order_notification)  {
          this.alertAdvanceSalesOrderNotify = true;
          this.numAdvanceSalesOrderNotify = 1;
        } else {
          this.alertAdvanceSalesOrderNotify = false;
          this.numAdvanceSalesOrderNotify = 0;
        }
        this.onload = false;
      },
      switchNewVersionOrderList: function () {
        const setArray = ['order'];
        Cookies.set('new_version',JSON.stringify(setArray));
        this.$router.go(this.$router.currentRoute)
      },
      switchOldVersionOrderList: function () {
        const cookieValue = Cookies.get('new_version');
        const myArray = JSON.parse(cookieValue);
        const indexToRemove = myArray.indexOf('order');
        if (indexToRemove !== -1) {
          myArray.splice(indexToRemove, 1);
          Cookies.set('new_version',JSON.stringify(myArray));
        }

        this.$router.go(this.$router.currentRoute)
      }
    },
    mounted() {
      this.getCountdownChangePassword();
      this.getBusinessInfoList();
      this.getAlertAdvanceSalesOrderNotify();
      this.getBankAccount();
      this.getFlatRate();
    },
    watch: {
      $refreshalert() {
        this.tenant = JSON.parse(Cookies.get('tenant'));
        this.getCountdownChangePassword();
        this.getBusinessInfoList();
        this.getAlertAdvanceSalesOrderNotify();
        this.getBankAccount();
        this.getFlatRate();
      },
    },
  };
</script>
<style>
  .button-next-prev-nas {
    margin-right: -30px;
    float: right;
    color: white;
  }
  .button-color-nas-next-prev {
    background-color: #ff7043;
    border: 0px;
    color: white;
  }
  .alert .carousel .left.carousel-control,
  .alert .carousel .right.carousel-control {
    background-image: none;
    color: inherit;
    text-shadow: none;
    width: 2%;
    opacity: 1;
  }

  .alert .carousel .item {
    height: 30px;
  }

  .alert .carousel-caption-nas {
    padding: 0;
    bottom: 5px;
    left: 4%;
    text-align: left;
    text-shadow: none;
  }
  /*
  remove margin-bottom
  */
  .no-bottom-margin {
    margin-bottom: 0px !important;
  }

  .alert-order {
    color: #1f90e9 !important;
    background-color: #DBEEFD;
  }

  .u_line {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/AlertOrder.vue